import { ConsultaSeguimentoAplicacaoItemModel } from '@mchat-rf/consulta-seguimento/model-consultaSeguimento'
import { SimNaoEnum } from 'components/form'

export enum ConsultaSeguimentoPergunta04GostaDeSubirEmEnum {
  ESCADAS = 'ESCADAS',
  CADEIRAS = 'CADEIRAS',
  MOVEIS = 'MOVEIS',
  BRINQUEDOS = 'BRINQUEDOS',
}

export interface ConsultaSeguimentoPergunta04Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_04_HEADER?: SimNaoEnum
  PERGUNTA_04_GOSTA_DE_SUBIR_EM?: Record<ConsultaSeguimentoPergunta04GostaDeSubirEmEnum, SimNaoEnum | undefined>
}
